import { DatasetLoadingConf } from "../charts/interfaces";
import { IDateRange } from "../product-template-table/utils/interfaces";

export enum Axis {
  X_AXIS = "xAxis",
  Y_AXIS = "yAxis",
}

export enum ColorKey {
  MIN_COLOR = "minColor",
  MAX_COLOR = "maxColor",
}

export const defaultMinColor = "#daedf2";
export const defaultMaxColor = "#3376b0";

export interface IGridHeatmapEditorProps extends IDateRange {
  xAxis: {
    title: string;
    identifier: string;
    minValue?: number;
    maxValue?: number;
  };
  yAxis: {
    title: string;
    identifier: string;
    minColor?: string;
    maxColor?: string;
    minValue?: number;
    maxValue?: number;
  };
  yAxisSecondary?: {
    title: string;
    identifier: string;
    minColor?: string;
    maxColor?: string;
    minValue?: number;
    maxValue?: number;
  };
  isLoadConfig: boolean;
  chartTitle?: string;
  axisStepSize?: number;
  minColor?: string;
  maxColor?: string;
  loadConf?: DatasetLoadingConf;
  hideHeader?: boolean;
}
